import { graphql } from "@/lib/gql/__generated__";

export const OPTION_PMS_ITEM_CANCEL_FOR_OPTION_PMS_MUTATION = graphql(/* GraphQL */ `
	mutation OptionPmsItemCancelForOptionPms($input: OptionPmsItemCancelInput!) {
		optionPmsItemCancel(input: $input) {
			optionPmsItem {
				id
				hotelID
				itemType
				reservationID
				uniqueID
				date
				guestName
				guestTel
				optionID
				subOptionID
				optionName
				subOptionName
				amount
				optionStartAt
				optionEndAt
				planName
				roomNum {
					adultNum
					kidsNum {
						age
						asCosleeping
					}
					uniqueRoomID
				}
				questions {
					question
					answer
				}
				memo
				canDelete
				isCanceled
			}
			userErrors
		}
	}
`);
